const BlogItem=(props)=>{
  return (
    <>
    <div className="column">
      <div className="blogbox">
        <h3>{props.item.post_title}</h3>
        <p>{props.item.post_sub_title}</p>
        <div className="blog-person"><img src={props.item.avatar_url} /></div>
        <div className="writtenby">Written By: <span>{props.item.firstname} {props.item.lastname}</span></div>
        <a href={"/blog/"+props.item.post_url} className="blog-readmore">Read More</a>
      </div>
    </div>
    </>
  );
};
export default BlogItem; 